import { useState, useEffect } from 'react';
import { X, Download } from 'lucide-react';

export const PWAInstallBanner = () => {
  const [show, setShow] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    // Don't show if already dismissed within 30 days
    const dismissed = localStorage.getItem('pwa_install_dismissed');
    if (dismissed && Date.now() - parseInt(dismissed) < 30 * 24 * 60 * 60 * 1000) return;
    
    // Don't show if already installed (standalone mode)
    if (window.matchMedia('(display-mode: standalone)').matches) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShow(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setShow(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShow(false);
    localStorage.setItem('pwa_install_dismissed', Date.now().toString());
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 lg:left-auto lg:right-8 lg:w-96 z-40 
                    bg-emerald-900 text-white rounded-xl shadow-2xl p-4 
                    flex items-center gap-3 animate-in slide-in-from-bottom-4"
         data-testid="pwa-install-banner"
    >
      <Download className="w-8 h-8 text-amber-400 shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium">Instala Pichiroces como app</p>
        <p className="text-xs text-emerald-200 mt-0.5">Accede más rápido desde tu móvil</p>
      </div>
      <button
        onClick={handleInstall}
        className="shrink-0 bg-amber-500 hover:bg-amber-400 text-emerald-950 text-xs font-semibold px-4 py-2 rounded-lg transition-colors"
        data-testid="pwa-install-btn"
      >
        Instalar
      </button>
      <button
        onClick={handleDismiss}
        className="shrink-0 p-1 hover:bg-emerald-800 rounded-full transition-colors"
        data-testid="pwa-dismiss-btn"
      >
        <X className="w-4 h-4 text-emerald-300" />
      </button>
    </div>
  );
};
